const streetStartBetLevel = (street, bigBlind) => street === 'preflop' ? bigBlind : 0;
export const deriveStreetBettingState = (bigBlind, street, streetActions) => {
    let betLevel = streetStartBetLevel(street, bigBlind);
    let increment = bigBlind;
    let lastFullRaiseIndex = -1;
    const lastActionIndexBySeat = new Map();
    streetActions.forEach((action, i) => {
        lastActionIndexBySeat.set(action.seat, i);
        if ((action.kind === 'bet' || action.kind === 'raise' || action.kind === 'jam') &&
            action.amount !== undefined &&
            action.amount > betLevel) {
            const raiseIncrement = action.amount - betLevel;
            if (raiseIncrement >= increment) {
                increment = raiseIncrement;
                lastFullRaiseIndex = i;
            }
            betLevel = action.amount;
        }
    });
    return { currentBet: betLevel, minRaiseTo: betLevel + increment, lastActionIndexBySeat, lastFullRaiseIndex };
};
export const streetActionsOf = (state) => state.history.filter((h) => h.street === state.street).map((h) => h.action);
/** Does `seat` currently hold the raise option, or only call/fold (short all-in already happened
 *  since their last action, with no full raise since to reopen it)? */
export const hasOpenRaiseRight = (state, seat) => {
    const bigBlind = state.spec.stakes.bb;
    const streetActions = streetActionsOf(state);
    const { lastActionIndexBySeat, lastFullRaiseIndex } = deriveStreetBettingState(bigBlind, state.street, streetActions);
    const seatLastActionIdx = lastActionIndexBySeat.get(seat);
    return seatLastActionIdx === undefined || lastFullRaiseIndex > seatLastActionIdx;
};
//# sourceMappingURL=betting.js.map